import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  NavigationExtras,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { AppConfigurationService } from "./services/ipc-app-configuration.service";

@Injectable()
export class AppConfigurationLoadedGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router, private appConfigurationService: AppConfigurationService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.appConfigurationService.configurationsLoaded.pipe(
      tap(
        (isLoaded$) =>
          !isLoaded$ &&
          this.router.navigate(["invoices-payments", "error"], { fragment: "features" } as NavigationExtras)
      )
    );
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    if (childRoute.data.skipGuard) {
      return true;
    }

    return this.canActivate(childRoute, state);
  }
}
